export default "__VITE_ASSET__BB$oPtWT__"